module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_styled_01-1ff1653d170e02c0d55c1bd4ac60c476.png";